import type { iSupplierBill } from "@sdk/supplier-bills/supplier-bill-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectSupplierBillQueryMap,
  selectEntityMap: selectSupplierBillsMap,
  selectQueryMapAll: selectSupplierBillsMapAll,
  selectQueryAllList: selectSupplierBillsAllList,
  selectAllEntities: selectAllSupplierBills,
  selectAllEntitiesQuery: selectAllSupplierBillsQuery,
  selectEntityById: selectSupplierBillById,
  selectEntityQuery: selectSupplierBillQuery,
  selectEntityQueryList: selectSupplierBillQueryList,
} = CreateSelectorForEntities<iStore, iSupplierBill>({
  sliceName: "supplierBills",
});

export const selectSupplierBillByProductId =
  (productId: string) =>
  (state: iStore): iSupplierBill | undefined => {
    const byIds = state.supplierBills?.byIds ?? {};
    const billIds = state.supplierBills?.queries
      ? Object.values(state.supplierBills.queries).flatMap((q) => q?.list ?? [])
      : [];
    return billIds
      .map((id) => byIds[id])
      .find((b): b is iSupplierBill => b?.productId === productId);
  };
